import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #e4e9f2;
`;

export const FightsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Fight = styled.div`
  width: 25%;
  padding: 1%;
  margin: 1%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #f4f4f4;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.13), 0 1px 1px 0 rgba(0, 0, 0, 0.11);
  background: #fff;
  .red-corner {
    color: rgb(255, 99, 132);
  }

  .blue-corner {
    color: rgb(54, 162, 235);
  }
`;

export const CustomLink = styled(Link)`
  text-decoration: none;
  // color #f4f4f4;
  font-size: 1.2em;
  margin: 2%;

  &:hover {
    color: rgb(255, 144, 0);
  }
`;
